<div class="p-4 max-w-3xl mx-auto">
  <h2 class="text-2xl font-bold mb-6">
    {{ isEditMode ? ('::EditPickupPoint' | abpLocalization) : ('::NewPickupPoint' | abpLocalization) }}
  </h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
    <app-metro-form-input
      label="{{ '::Name' | abpLocalization }}"
      formControlName="name"
      [placeholder]=" '::Name' | abpLocalization"
      size="md"
      type="text">
    </app-metro-form-input>

    <app-metro-form-input
      label="{{ '::Address' | abpLocalization }}"
      formControlName="address"
      [placeholder]=" '::Address' | abpLocalization"
      size="md"
      type="text">
    </app-metro-form-input>

    <app-metro-form-input
      label="{{ '::Email' | abpLocalization }}"
      formControlName="email"
      [placeholder]=" '::Email' | abpLocalization"
      size="md"
      type="email">
    </app-metro-form-input>

    <!-- winepassport#342 / #379 — provincia / localidad del punto de retiro -->
    <app-metro-form-select
      label="{{ '::Province' | abpLocalization }}"
      formControlName="province"
      [placeholder]="'::Province' | abpLocalization"
      [options]="provinceOptions"
      [allowSearch]="false"
      (selectionChange)="onProvinceChange($event)"
      size="md">
    </app-metro-form-select>

    <!-- winepassport#379 — localidad dependiente de la provincia. Select con buscador
         cuando hay catálogo; texto libre si la provincia es "Otra" o no tiene localidades. -->
    <app-metro-form-select *ngIf="!cityAsFreeText; else cityFreeText"
      label="{{ '::City' | abpLocalization }}"
      formControlName="city"
      [placeholder]="'::City' | abpLocalization"
      [options]="localityOptions"
      [allowSearch]="true"
      size="md">
    </app-metro-form-select>
    <ng-template #cityFreeText>
      <app-metro-form-input
        label="{{ '::City' | abpLocalization }}"
        formControlName="city"
        [placeholder]=" '::City' | abpLocalization"
        size="md"
        type="text">
      </app-metro-form-input>
    </ng-template>

    <app-metro-form-input
      label='{{"::ExternalWarehouseName" | abpLocalization}}'
      formControlName="colppyWarehouseName"
      [placeholder]='"::ExternalWarehouse" | abpLocalization'
      size="md"
      type="text">
    </app-metro-form-input>

    <!-- Is Active -->
    <div class="flex items-center">
      <input id="isActive" type="checkbox" formControlName="isActive"
        class="w-4 h-4 text-metro-red bg-gray-100 border-gray-300 rounded focus:ring-metro-red">
      <label for="isActive" class="ml-2 text-sm font-medium text-gray-900">{{ "::IsActive" | abpLocalization }}</label>
    </div>

    <!-- Is Visible -->
    <div class="flex items-center">
      <input id="isVisible" type="checkbox" formControlName="isVisible"
        class="w-4 h-4 text-metro-red bg-gray-100 border-gray-300 rounded focus:ring-metro-red">
      <label for="isVisible" class="ml-2 text-sm font-medium text-gray-900">{{ "::IsVisible" | abpLocalization }}</label>
    </div>

    <!-- Buttons -->
    <div class="flex justify-end pt-4 gap-2">
      <app-metro-button
        variant="secondary"
        text="{{ '::Cancel' | abpLocalization }}"
        (clicked)="onCancel()">
      </app-metro-button>
      <app-metro-button
        variant="primary"
        text="{{ isEditMode ? ('::SaveChanges' | abpLocalization) : ('::AddPickupPoint' | abpLocalization) }}"
        type="submit">
      </app-metro-button>
    </div>
  </form>
</div>
